
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M-1-1h21v21H-1z"}}),_c('path',{attrs:{"fill":"#4A4A4A","fill-rule":"nonzero","d":"M4.492 14.653a2.578 2.578 0 014.862 0h8.737v1.718H9.354a2.578 2.578 0 01-4.862 0H.909v-1.718h3.583zm5.154-6.012a2.578 2.578 0 014.862 0h3.583v1.718h-3.583a2.578 2.578 0 01-4.862 0H.909V8.64h8.737zM4.491 2.63a2.578 2.578 0 014.863 0h8.737v1.718H9.354a2.578 2.578 0 01-4.862 0H.909V2.629h3.583z"}})])])
          )
        }
      }
    